import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { useCallback, useMemo, useState } from 'react';
import Modal from '../UI/Modal';
export default function useModal() {
    const [modalContent, setModalContent] = useState(null);
    const onClose = useCallback(() => {
        setModalContent(null);
    }, []);
    const modal = useMemo(() => {
        if (modalContent === null) {
            return null;
        }
        const { title, content, closeOnClickOutside } = modalContent;
        return (_jsx(Modal, { onClose: onClose, title: title, closeOnClickOutside: closeOnClickOutside, children: content }));
    }, [modalContent, onClose]);
    const showModal = useCallback((title, 
    // eslint-disable-next-line no-shadow
    getContent, closeOnClickOutside = true) => {
        setModalContent({
            closeOnClickOutside,
            content: getContent(onClose),
            title,
        });
    }, [onClose]);
    return [modal, showModal];
}
